import { createSlice } from '@reduxjs/toolkit';
import { Analytics } from 'packages';

const viewItemSlice = createSlice({
    name: 'viewItem',
    initialState: {},
    reducers: {
        setDescription: (state, { payload }) => {
            state.descriptions[payload.languageCodeIso2] = { ...payload };
            state.descriptionLoading = false;
            state.descriptionLoadingError = false;
        },
        showTranslatedDescription: {
            reducer: (state, { payload }) => {
                state.showTranslatedDescription = payload.show;
            },
            prepare: payload => {
                Analytics.trackEvent({
                    category: 'View Item Page',
                    action: 'Translation',
                    label: payload.show ? `Show - ${payload.language}` : 'Hide'
                });
                return { payload };
            }
        },
        beginLoadingDescription: state => {
            state.descriptionLoading = true;
            state.descriptionLoadingError = false;
        },
        failedLoadingDescription: state => {
            state.descriptionLoading = false;
            state.descriptionLoadingError = true;
        }
    }
});

export const {
    setDescription,
    showTranslatedDescription,
    beginLoadingDescription,
    failedLoadingDescription
} = viewItemSlice.actions;

export default viewItemSlice.reducer;
